import { Skeleton } from "antd";
import React, { useContext } from "react";
import { TimeTrackingUserDataContext } from "../../TimeTrackingUserDataProvider";
import { SessionsHistory } from "../History/SessionsHistory";
import { TrackerRow } from "./Inputs";
import CalendarTracking from "./Inserts/CalendarTracking";
import { TrackerContext } from "./utils/types";

interface TrackerProps {
  defaultProjectId?: string;
}
export const Tracker: React.FC<TrackerProps> = () => {
  const { typeOfTracking } = useContext(TrackerContext);
  const { isGettingInitialData } = React.useContext(
    TimeTrackingUserDataContext,
  );
  return (
    <>
      <div
        style={{
          marginBottom: 20,
          width: "100%",
        }}
      >
        {isGettingInitialData ? <Skeleton active /> : <TrackerRow />}
      </div>
      {typeOfTracking !== "Calendar" ? (
        <SessionsHistory />
      ) : (
        <CalendarTracking />
      )}
    </>
  );
};
